import SalesActivityActionCreators from "../../store/actions/SalesActivity";
import {
	SalesActivity,
	GetOneSaleActivityRequest
} from "@/Contracts/Others/SalesActivity";
// import { useLocation } from "react-router-dom";
import { ZomentumRoutes } from "@/Contracts";
import useRefreshSalesActivity from "./useRefreshSalesActivity";
import { useSalesActivityModuleDispatch } from "../../store";
import { useContext } from "react";
import { ParentContext } from "../../store/context/ParentContext";
import { isPartnerApp } from "@/Utils";

const useHandleAddSalesActivity = (): Record<string, any> => {
	const parentContext = useContext(ParentContext);
	const { currentActiveOpportunity } = parentContext.opportunity;
	const { companyUserList } = parentContext.user;

	const dispatch = useSalesActivityModuleDispatch();
	// const location = useLocation();
	const refreshSalesActivity = useRefreshSalesActivity();

	const fetchUpdatedOpportunities = (opportunityId?: string) => {
		parentContext.opportunity.syncKanbanOpportunityDataById(
			opportunityId || (currentActiveOpportunity?.id ?? "")
		);
	};

	const handleAddSalesActivity = async (
		salesActivity: SalesActivity,
		opportunityId?: string
	) => {
		try {
			if (window.location.pathname === ZomentumRoutes.SalesActivityPage) {
				const taskActivity = await dispatch(
					SalesActivityActionCreators.fetchOneSalesActivity(
						new GetOneSaleActivityRequest(
							salesActivity.id,
							salesActivity.feed_type
						),
						companyUserList
					)
				);
				await dispatch(
					SalesActivityActionCreators.addActivityToUsersSalesActivity(
						taskActivity.salesActivity
					)
				);
			} else if (
				window.location.pathname === ZomentumRoutes.OpportunityList ||
				window.location.pathname ===
					ZomentumRoutes.VendorOpportunityList
			) {
				fetchUpdatedOpportunities(opportunityId);
			} else if (
				window.location.pathname.startsWith(
					`${ZomentumRoutes.OpportunityList}/`
				) ||
				window.location.pathname.startsWith(
					`${ZomentumRoutes.ClientsList}/`
				) ||
				window.location.pathname.startsWith(
					`${ZomentumRoutes.VendorOpportunityList}/`
				) ||
				window.location.pathname.startsWith(
					`${ZomentumRoutes.VendorClientList}/`
				) ||
				window.location.pathname.startsWith(
					`${ZomentumRoutes.VendorPartnerList}/`
				)
			) {
				refreshSalesActivity();
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleCloseAddSalesActivity = () => {
		if (
			window.location.pathname === ZomentumRoutes.OpportunityList &&
			isPartnerApp()
		) {
			parentContext.opportunity.resetOpportunityDetails();
		} else if (
			window.location.pathname === ZomentumRoutes.ClientsList &&
			isPartnerApp()
		) {
			parentContext.client.resetClientDetails();
		} else if (
			window.location.pathname.startsWith(
				`${ZomentumRoutes.OpportunityList}/`
			) ||
			window.location.pathname.startsWith(
				`${ZomentumRoutes.ClientsList}/`
			) ||
			window.location.pathname.startsWith(
				`${ZomentumRoutes.VendorPartnerList}/`
			) ||
			window.location.pathname.startsWith(
				`${ZomentumRoutes.VendorOpportunityList}/`
			)
		) {
			refreshSalesActivity();
		}
	};

	return {
		handleAddSalesActivity,
		handleCloseAddSalesActivity
	};
};

export default useHandleAddSalesActivity;
